/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceDetailsResource
 */
export interface InvoiceDetailsResource {
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsResource
     */
    maltFeesRate: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsResource
     */
    taxesRate: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsResource
     */
    priceOutOfTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsResource
     */
    feesOutOfTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsResource
     */
    subTotalOutOfTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsResource
     */
    taxes: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsResource
     */
    totalIncludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsResource
     */
    alreadyPaidAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsResource
     */
    dueAmount?: number;
}

/**
 * Check if a given object implements the InvoiceDetailsResource interface.
 */
export function instanceOfInvoiceDetailsResource(value: object): value is InvoiceDetailsResource {
    if (!('maltFeesRate' in value) || value['maltFeesRate'] === undefined) return false;
    if (!('taxesRate' in value) || value['taxesRate'] === undefined) return false;
    if (!('priceOutOfTaxes' in value) || value['priceOutOfTaxes'] === undefined) return false;
    if (!('feesOutOfTaxes' in value) || value['feesOutOfTaxes'] === undefined) return false;
    if (!('subTotalOutOfTaxes' in value) || value['subTotalOutOfTaxes'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    if (!('totalIncludingTaxes' in value) || value['totalIncludingTaxes'] === undefined) return false;
    return true;
}

export function InvoiceDetailsResourceFromJSON(json: any): InvoiceDetailsResource {
    return InvoiceDetailsResourceFromJSONTyped(json, false);
}

export function InvoiceDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'maltFeesRate': json['maltFeesRate'],
        'taxesRate': json['taxesRate'],
        'priceOutOfTaxes': json['priceOutOfTaxes'],
        'feesOutOfTaxes': json['feesOutOfTaxes'],
        'subTotalOutOfTaxes': json['subTotalOutOfTaxes'],
        'taxes': json['taxes'],
        'totalIncludingTaxes': json['totalIncludingTaxes'],
        'alreadyPaidAmount': json['alreadyPaidAmount'] == null ? undefined : json['alreadyPaidAmount'],
        'dueAmount': json['dueAmount'] == null ? undefined : json['dueAmount'],
    };
}

export function InvoiceDetailsResourceToJSON(value?: InvoiceDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maltFeesRate': value['maltFeesRate'],
        'taxesRate': value['taxesRate'],
        'priceOutOfTaxes': value['priceOutOfTaxes'],
        'feesOutOfTaxes': value['feesOutOfTaxes'],
        'subTotalOutOfTaxes': value['subTotalOutOfTaxes'],
        'taxes': value['taxes'],
        'totalIncludingTaxes': value['totalIncludingTaxes'],
        'alreadyPaidAmount': value['alreadyPaidAmount'],
        'dueAmount': value['dueAmount'],
    };
}

